module.exports = __webpack_public_path__ + "static/media/lafise-off-app-provider-icon.ace44303.svg";